<div class="row">
  @for (date of dates; track date) {
    <div class="col date">
      {{ date | dateParse | dateFormat: 'ddd D' }}
    </div>
  }
</div>
<div class="row">
  @for (date of dates; track date) {
    <div class="column col">
      @for (item of getSortedTimes(date); track item) {
        <div class="capability"
         [ngClass]="{
         'zero-employees': hasNoEmployees(item),
         'keyholder': isKeyholder(item),
         'banking': isBanking(item),
         'changeover': isChangeover(item),
         'salesperson': isSalesPerson(item),
         'changeover-manager': isChangeoverManager(item),
         'shop-opener': isShopOpener(item),
         'shop-closer': isShopCloser(item)
         }">
          @if (item.startTime && !happensAllDay(item)) {
            <p class="capability-time">
              {{ item.startTime | timeParse | dateFormat: 'HH:mm' }} -
              {{ item.endTime | timeParse | dateFormat: 'HH:mm' }}
            </p>
          }
          <p class="employees-available">
            {{ item.availableEmployees.length }} Available
            @if (isKeyholder(item)) {
              <span>{{ item.availableEmployees.length > 1 ? 'Keyholders' : 'Keyholder' }}</span>
            }
            @if (isBanking(item)) {
              <span>for Banking
                <span>
                  @switch (happensAllDay(item)) {
                    @case (true) {
                      <span>(Preparation)</span>
                    }
                    @case (false) {
                      <span>(Handover)</span>
                    }
                  }
                </span>
              </span>
            }
            @if (isChangeover(item)) {
              <span>({{ item.requiredEmployees }} Required) for Changeover</span>
            }
            @if (isSalesPerson(item)) {
              <span>Salesperson</span>
            }
            @if (isChangeoverManager(item)) {
              <span>Changeover manager</span>
            }
            @if (isShopOpener(item)) {
              <span>Shop opener</span>
            }
            @if (isShopCloser(item)) {
              <span>Shop closer</span>
            }
          </p>
          <p class="employee-list">
            @for (employee of findAvailableEmployees(item); track employee) {
              <span class="employee-name">
                &#8226; {{ employee.name }}
              </span>
            }
          </p>
        </div>
      }
    </div>
  }
</div>
